import { decode as base64_decode, encode as base64_encode } from "base-64";

import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import Cookies from "js-cookie";
import { notification } from "antd";

class BookingStore {
  vehicleTypes = [];
  bookingData = [];

  total = 0;
  loading = false;

  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      loading: observable,

      vehicleTypes: observable,
      bookingData: observable,

      loadData: action,
      searchCustomer: action,
      getVehicleType: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({ companyId, status, isadmin, userId }) {
    this.loading = true;

    var postData = {
      companyId: companyId,
      offset: 0,
      limit: 50,
      status: status,
      isadmin: isadmin,
      userId: userId,
    };

    const base64Input = await base64_encode(JSON.stringify(postData));

    var response = await postApi
      .getClient()
      .post(
        "index.php?c=traxi_booking&a=getBookings",
        "postData=" + base64Input
      );

    this.total = parseInt(response?.data?.data?.TotalCount);
    this.bookingData = response?.data?.data?.bookingDetails;
    this.loading = false;
  }

  async searchCustomer({ companyId, mobileNo }) {
    var postData = { companyId: companyId, mobileNo: mobileNo };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post(
        "index.php?c=traxi_booking&a=searchRider",
        "postData=" + base64Input
      );

    return response.data?.data?.riderDetails;
  }
  async bookingRequest({
    pickupAddress,
    dropAddress,
    customerName,
    taxiTypeId,
    noOfPassenger,
    Nationality,
    pickupLatitude,
    pickupLongitude,
    customerContactNo,
    dropLatitude,
    dropLongitude,
    companyId,
    isadmin,
    customerId,
    radius,
    driverResponseTime,
    taxiSearchTime,
    bookingDateTime,
    advancedBookingDate,
    isAdvancedBooking,
    noOfBags,

    speacialAssistance,
  }) {
    var postData = {
      pickupAddress: pickupAddress,
      dropAddress: dropAddress,
      Nationality: Nationality,
      taxiTypeId: taxiTypeId,
      companyId: companyId,
      noOfPassenger: noOfPassenger,
      customerName: customerName,
      pickupLatitude: pickupLatitude,
      pickupLongitude: pickupLongitude,
      customerContactNo: customerContactNo,
      dropLatitude: dropLatitude,
      dropLongitude: dropLongitude,
      companyId: companyId,
      isadmin: isadmin,
      customerId: customerId,
      radius: radius,
      driverResponseTime: driverResponseTime,
      taxiSearchTime: taxiSearchTime,
      bookingDateTime: bookingDateTime,
      advancedBookingDate: advancedBookingDate,
      isAdvancedBooking: isAdvancedBooking,
      noOfBags: noOfBags,
      speacialAssistance: speacialAssistance,
    };

    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post(
        "index.php?c=traxi_booking&a=bookingRequest",
        "postData=" + base64Input
      );

    return response.data?.data;
  }

  async getBookingStatus({
    customerId,
    bookingId,
    taxiTypeId,
    companyId,
    isadmin,

    radius,
    driverResponseTime,
    taxiSearchTime,
    notificationId,
  }) {
    var postData = {
      customerId: customerId,
      vehicleTypeId: taxiTypeId,
      companyId: companyId,
      bookingId: bookingId,
      notificationId: notificationId,
      isadmin: isadmin,
      radius: radius,
      driverResponseTime: driverResponseTime,
      taxiSearchTime: taxiSearchTime,
    };

    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post(
        "index.php?c=traxi_booking&a=checkBookingRequestStatus",
        "postData=" + base64Input
      );

    return response.data?.data;
  }

  async getVehicleType() {
    var postData = {};
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post(
        "index.php?c=traxi_vehicle&a=getTaxiType",
        "postData=" + base64Input
      );

    this.vehicleTypes = response.data.data;
  }

  // async c=traxi_booking&a=getFareDetails

  async getFareDetails({
    taxiTypeId,
    bookingDateTime,
    dropLatitude,
    dropLongitude,
    pickupLatitude,
    pickupLongitude,
  }) {
    var postData = {
      pickupLatitude: pickupLatitude,
      pickupLongitude: pickupLongitude,
      dropLatitude: dropLatitude,
      dropLongitude: dropLongitude,
      companyId: "1",
      duration: 0,
      bookingDateTime: bookingDateTime,
      taxiTypeId: taxiTypeId,
    };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post(
        "index.php?c=traxi_booking&a=getFareDetails",
        "postData=" + base64Input
      );

    this.fareDetails = response.data.data;
  }
}

export default BookingStore;
